import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TopupComponent } from '@teem/wallets-module/modals/topup/topup.component';
import { WithdrawComponent } from '@teem/wallets-module/modals/withdraw/withdraw.component';
import { WalletService } from '@teem/services/wallet.service';

declare var $;

@Component({
	selector: 'app-wallets',
	templateUrl: './wallets.component.html',
	styleUrls: ['./wallets.component.scss']
})


export class WalletsComponent implements OnInit, AfterViewInit {
	balance: number = 0;
	cards: any;
	currency: string = 'SAR';
	transactions: any[] = [];
	savedCards: any[] = [];
	// currentPage: number = 1;
	// totalPages: number = 1;
	perPage: number = 5;
	walletStatus: string = 'old';
	minBalanceBanner: number = 50;
	isAutoRenewEnabled: boolean = false; // Default value

	@Input() totalPages: number = 1; // Total number of pages
	@Input() currentPage: number = 1; // Current active page
	@Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
	pages: number[] = []; // Array of page numbers
	paginationRange: (number | string)[] = [];

	constructor( private walletService: WalletService ) {}


	ngOnInit(): void {
		this.fetchBalance();
		this.fetchTransactionHistory();
		this.generatePages();
		// console.log('WalletsComponent OnInit lifecycle hook triggered');
	}

	// Generate pages array dynamically
	generatePages() {
		this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
	}

	fetchBalance(): void {
		this.walletService.getBalance().subscribe(
			(data: any) => {
				if (data && data.balance !== undefined) {
					this.balance = data.balance;
				}
				if (data && data.currency !== undefined) {
					this.currency = data.currency;
				}
				if (data && data.cards !== undefined) {
					this.cards = data.cards;
				}
				if (data && data.new_wallet !== undefined) {
					this.walletStatus = data.new_wallet;
				}
				if (data && data.autoRenew !== undefined) {
					// this.isAutoRenewEnabled = (data.autoRenew == 1) ? true : false;
					this.isAutoRenewEnabled = (data.autoRenew == 1) ? false : true;
				}

				if (data && data.savedCards !== undefined) {
					// this.isAutoRenewEnabled = (data.autoRenew == 1) ? true : false;
					this.savedCards = data.savedCards;
				}
			},
			(error) => {
				console.error('Error fetching balance:', error);
			}
		);
	}

	fetchTransactionHistory(page: number = 1): void {
		this.walletService.getTransactions(page, this.perPage).subscribe(
			(response: any) => {
				if (response) {
					this.transactions = response.data;
					this.currentPage = response.current_page;
					this.totalPages = response.last_page;
					this.generatePages();
					this.updatePaginationRange();
				}
			},
			(error) => {
				console.error('Error fetching balance:', error);
			}
		);
	}

	getVisiblePages(): number[] {
		const maxVisible = 5;
		let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
		let end = Math.min(this.totalPages, start + maxVisible - 1);
		
		if (end - start + 1 < maxVisible) {
				start = Math.max(1, end - maxVisible + 1);
		}
		
		const visiblePages: number[] = [];
		for (let i = start; i <= end; i++) {
				visiblePages.push(i);
		}
		
		return visiblePages;
	}

	getStartItem(): number {
		return (this.currentPage - 1) * this.perPage + 1;
	}

	getEndItem(): number {
		const end = this.currentPage * this.perPage;
		const totalItems = this.totalPages * this.perPage; 
		return end > totalItems ? totalItems : end;
	}

	autoRenewUpdate(isAutoRenewEnabled: any) {
		this.isAutoRenewEnabled = !isAutoRenewEnabled;
		this.walletService.updateAutoRenew().subscribe();
	}

	onPerPageChange(value: any): void {
		this.currentPage = 1;  // Reset to the first page
		this.perPage = value
		this.fetchTransactionHistory();
	}

	nextPage(): void {
		if (this.currentPage < this.totalPages) {
			this.goToPage(this.currentPage + 1);
		}
	}

	prevPage(): void {
		if (this.currentPage > 1) {
			this.goToPage(this.currentPage - 1);
		}
	}

	goToPage(page: number): void {
		if (page !== this.currentPage) {
			this.currentPage = page;
			this.updatePaginationRange();
			this.fetchTransactionHistory(this.currentPage);
		}
	}

	ngAfterViewInit(): void {
		// console.log('View of WalletsComponent is fully initialized');
	}

	@ViewChild(TopupComponent) modalComponent!: TopupComponent;
	@ViewChild(WithdrawComponent) withdrawModalComponent!: WithdrawComponent;

	openTopUpModal() {
		this.modalComponent.open();
	}

	openWithdrawModal() {
		 // Ensure the modal component is initialized before accessing it
		 if (this.withdrawModalComponent) {
			this.withdrawModalComponent.balance = this.balance;
			this.withdrawModalComponent.currency = this.currency;
		  }
		this.withdrawModalComponent.withdrawModalOpen();
	}

	// Set this dynamically from Laravel response
	updatePaginationRange() {
		const delta = 1; // Show 1 page before and after current page
		const range: (number | string)[] = [];

		const left = Math.max(2, this.currentPage - delta);
		const right = Math.min(this.totalPages - 1, this.currentPage + delta);

		range.push(1); // Always show first page

		if (left > 2) {
			range.push('...');
		}

		for (let i = left; i <= right; i++) {
			range.push(i);
		}

		if (right < this.totalPages - 1) {
			range.push('...');
		}

		if (this.totalPages > 1) {
			range.push(this.totalPages); // Always show last page
		}

		this.paginationRange = range;
	}
}